import styled from 'styled-components';

export const ContainerInput = styled.div`
  margin: 0px 3px;
`;
